export const SEARCH_KEYS = ['character', 'signature', 'theme', 'style', 'outfit', 'pose', 'expression', 'scene', 'cast', 'pair',
    'artwork', 'environment', 'line', 'abstraction', 'palette', 'palette-variant', 'composition', 'angle', 'rating'] as const;

export function searchFilters(params: URLSearchParams): URLSearchParams {
    const filters = new URLSearchParams();
    [...SEARCH_KEYS, 'year', 'month', 'color'].forEach(key => { const value = params.get(key); if (value) filters.set(key, value); });
    const tags = Array.from(new Set([...(params.get('tags') || '').split(','), params.get('word') || ''].map(value => value.trim()).filter(Boolean)));
    if (tags.length) filters.set('tags', tags.join(','));
    if (!filters.has('year')) filters.delete('month');
    return filters;
}

export function searchConditions(params: URLSearchParams): Array<{ key: string; value: string }> {
    const filters = searchFilters(params);
    const result = Array.from(filters).filter(([key]) => !['month', 'tags'].includes(key)).map(([key, value]) => ({ key, value }));
    if (filters.has('tags')) result.push(...filters.get('tags')!.split(',').map(value => ({ key: 'tags', value })));
    return result;
}

export function removeSearchCondition(params: URLSearchParams, key: string, value: string): URLSearchParams {
    const next = searchFilters(params);
    if (key === 'tags') {
        const tags = (next.get('tags') || '').split(',').filter(tag => tag !== value);
        if (tags.length) next.set('tags', tags.join(',')); else next.delete('tags');
    } else {
        next.delete(key);
        if (key === 'year') next.delete('month');
    }
    return next;
}

export function searchDetailSuffix(): string {
    const params = new URLSearchParams(window.location.search);
    const filters = searchFilters(params);
    filters.delete('year'); filters.delete('month');
    return params.get('page') === 'search' || params.get('search') === '1'
        ? `&search=1&${filters.toString()}${params.has('root') ? '&root=' + encodeURIComponent(params.get('root')!) : ''}` : '';
}
